import React from "react";
import { Table, TableCell, TableRow } from "../core/pdf/types";

export interface TableState {
	table: Table,
	addRowAbove: (relativeTo: TableCell) => TableRow | undefined,
	addRowBelow: (relativeTo: TableCell) => TableRow | undefined,
	addColAfter: (relativeTo: TableCell) => void,
	addColBefore: (relativeTo: TableCell) => void,

}

export const TableContext = React.createContext<TableState | undefined>(undefined);;

export function useTable() {
	return React.useContext(TableContext);
}
